/**
 * Model for menu items in KB Administration
 * Created by jacmai on 3/3/2017.
 */

define(["backbone"], function (Backbone) {
  var KbAdminMenuModel = {};

  KbAdminMenuModel.menuItem = Backbone.Model.extend({
    idAttribute: "name",
    defaults: {
      className: "",
    },
  });

  KbAdminMenuModel.menuItems = Backbone.Collection.extend({
    model: KbAdminMenuModel.menuItem,
  });

  KbAdminMenuModel.menuType = Backbone.Model.extend({
    default: {
      type: "pills",
      stacked: true,
    },
  });

  return KbAdminMenuModel;
});
